import {format} from 'd3';

import {SCORE_COLORS, SEMI_ACCESSIBLE_SCORE_COLORS} from '../styles/colors';

const fmt = format(',');

type ColorScheme = typeof SCORE_COLORS | typeof SEMI_ACCESSIBLE_SCORE_COLORS

export const impactScoreColor = (score: number, maxScore = 1) =>
  mapImpactScoreToColor(score, maxScore, SCORE_COLORS);

export const accessibleImpactScoreColor = (score: number, maxScore = 1) =>
  mapImpactScoreToColor(score, maxScore, SEMI_ACCESSIBLE_SCORE_COLORS)
;

const mapImpactScoreToColor = (score: number, maxScore = 1, colorScheme: ColorScheme) => {
  const step = maxScore / colorScheme.length;
  const index = Math.max(0, Math.min(colorScheme.length - 1, Math.floor(score / step)));
  return colorScheme[index];
};

export const impactScoreText = (score: number) => {
  return fmt(Math.ceil(score * 100));
};
